<template>
  <section id="admin-settings-search-filter">
    <el-collapse v-model="isOpen">
      <el-collapse-item
        :title="$t('common.search')"
        name="admin-settings-search-section"
        id="admin-settings-search-section"
      >
        <el-form
          id="admin-settings-search-section-form"
          class="search-section-form"
          :model="searchFormModel"
          ref="searchForm"
          label-position="right"
          size="mini"
          inline
          @submit.native.prevent
        >
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item :label="$t('admin.settings.description')">
                <el-input
                  v-model="searchFormModel.value"
                  v-alphanumeric-validation
                  clearable
                  @clear="handleSearch"
                  v-on:keyup.enter.native="handleSearch"
                  class="inline-input"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="16" class="text-align-end">
              <el-tooltip
                :content="$t('common.search')"
                class="item"
                effect="dark"
                placement="top-start"
              >
                <el-button
                  id="admin-settings-search-section-form-button"
                  class="button-action-default"
                  @click="handleSearch"
                  icon="el-icon-search"
                  size="mini"
                ></el-button>
              </el-tooltip>
            </el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
    </el-collapse>
  </section>
</template>

<script>
import { mapActions } from 'vuex';
import constants from '@/utils/constants';
import { ADMIN_SETTINGS_SEARCH } from '@/store/actions';

export default {
  name: 'AdminSettingsSearchSection',
  data() {
    return {
      activeCollapsibleName: ['admin-settings-search-section'],
      isOpen: ['admin-settings-search-section'],
      searchFormModel: {
        value: null,
        page: constants.TABLES.DEFAULT_PAGE
      }
    };
  },
  mounted() {
    this.handleSearch();
  },
  methods: {
    ...mapActions({
      search: ADMIN_SETTINGS_SEARCH
    }),
    handleSearch() {
      this.search(this.searchFormModel);
    }
  }
};
</script>
